export default "__VITE_ASSET__0sXalRns__"